// extracted by mini-css-extract-plugin
module.exports = {"mainMenu":"MainMenu_mainMenu__3pTGo"};